import { TyreFilter } from "@tm/models"
import { Filter } from "@tm/utils"
import { AvailabilityFilter } from "../../components"

export function isAvailabilityFilter(filter: TyreFilter | AvailabilityFilter | Filter): filter is AvailabilityFilter {
    return (filter as AvailabilityFilter).name !== undefined
}
